module.exports = __webpack_public_path__ + "static/media/cultura-brasileira.6850aa64.png";